export default __webpack_public_path__ + "static/media/gy.a1df57d3.svg";